import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/styles/variables.css'
import './assets/styles/element-theme.css'
import './assets/styles/base.css'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { createApp } from 'vue'

import App from './App.vue'
import router, { setupRouterGuards } from './router'
import './utils/axios'; // 初始化 Axios 拦截器

library.add(faFilePdf);

// 设置路由守卫
setupRouterGuards();

const app = createApp(App)
app.use(ElementPlus)
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(router)
app.mount('#app')
